import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { fadeUp } from "@/lib/motion";
import { AGENCIES } from "@/data/content";

const ExpertiseSection = () => {
  return (
    <section className="relative py-24 sm:py-32 bg-white" id="expertise" data-testid="expertise-section">
      <div className="max-w-[1320px] mx-auto px-5 sm:px-8">
        <SectionHeading
          overline="Regulatory Expertise"
          title="Deep Knowledge of India's Certification Agencies"
          description="We work hand-in-hand with the country's principal testing and certification authorities."
          className="mb-14"
        />

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {AGENCIES.map((a, i) => (
            <Reveal key={a.abbr} variants={fadeUp} custom={i % 3}>
              <div
                data-testid={`agency-card-${a.abbr.toLowerCase()}`}
                className="group relative h-full overflow-hidden rounded-2xl border border-slate-200 bg-[#F8FAFC] p-8 hover:bg-[#0F172A] hover:border-[#0F172A] transition-colors duration-400"
              >
                <div className="flex items-baseline gap-3">
                  <span className="font-display font-bold text-3xl text-[#1E40AF] group-hover:text-blue-300 transition-colors">
                    {a.abbr}
                  </span>
                </div>
                <p className="mt-1.5 text-sm font-medium text-slate-500 group-hover:text-slate-300 transition-colors">
                  {a.name}
                </p>
                <p className="mt-4 text-sm leading-relaxed text-slate-600 group-hover:text-slate-400 transition-colors">
                  {a.text}
                </p>
                <div className="absolute -bottom-10 -right-10 w-28 h-28 rounded-full bg-[#1E40AF]/5 group-hover:bg-[#2563EB]/20 transition-colors" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExpertiseSection;
